import { useEffect } from "react";
import "./Header.css";
import logo from "../../assets/images/logo_two.svg";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

import sidebar_logo from "../../assets/images/logo_two.svg";
import ru from "../../assets/ru.svg";
import tk from "../../assets/tk.svg";
import en from "../../assets/en.svg";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useFetchSloganData } from "../../hooks/useFetchSloganData";

const Header_main = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const mobile_sidebar = document.querySelector(".mobile_sidebar");
    mobile_sidebar.classList.remove("active");
  }, [location.pathname]);
  const menuActive = () => {
    const mobile_sidebar = document.querySelector(".mobile_sidebar");
    mobile_sidebar.classList.toggle("active");
  };

  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const items = [
    {
      img: en,
      value: "en",
    },
    {
      img: tk,
      value: "tk",
    },
    {
      img: ru,
      value: "ru",
    },
  ];

  const { slogan } = useFetchSloganData();

  return (
    <>
      <div className="Header_main pt-3 mb-3">
        <div className="container">
          <div
            className="flex justify-between main items-center text-center"
            style={{ alignItems: "center" }}
          >
            <div className="flex justify-between items-center max-[991px]:w-full">
              <div
                className="header_main_left  flex flex-col justify-center items-center"
                onClick={() => navigate("/")}
              >
                <div className="image">
                  <img src={logo} alt="" className="imgg" />
                </div>
                {/* <ul className="flex flex-col justify-center items-center text-[#0A940B]">
                                <li className='mx-auto text-left'>ASHGABAT INTERNATIONAL AIRPORT</li>
                                <li className='mx-auto text-left'>AŞGABAT HALKARA HOWA MENZILI</li>
                                </ul> */}
              </div>

              <div className="d-lg-none">
                <div className="menu_icon" onClick={menuActive}>
                  <MenuIcon />
                </div>
              </div>
            </div>
            <div
              className="header_main_right flex justify-content-end"
              style={{ alignItems: "center" }}
            >
              <div className="text pe-2 w-1/2 max-[991px]:w-full text-right">
                <div className="font-semibold uppercase xl:text-[18px] lg:text-[16px] sm:text-[14px]">
                  {/* <Translate title="year_logo" /> */}
                  {slogan?.translations[lang].title || ""}
                </div>
              </div>
              <div className="image">
                <img
                  src={slogan?.image}
                  alt="slogan"
                  className="w-[100px] h-auto"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mobile_sidebar d-xl-none pt-4 p-3">
          <div className="sidebar_close_icon text-white d-flex justify-content-end">
            <div className="close_icon" onClick={menuActive}>
              <CloseIcon />
            </div>
          </div>
          <div className="sidebar_logo">
            <div className="d-flex justify-content-center">
              <div className="image mt-4">
                <img src={sidebar_logo} alt="" className="logo-footer" />
              </div>
            </div>
          </div>
          <div className="sidebar_main mt-3">
            <h5 className="text-white">
              <Link to={"/"}>{t("home_page")}</Link>
            </h5>
            <h5 className="text-white">
              <Link to={"/about"}>{t("about_us")}</Link>
            </h5>
            <h5 className="text-white">
              <Link to={"/online_table"}>{t("online_table")}</Link>
            </h5>
            <h5 className="text-white">
              <Link to={"/passengers"}>{t("passengers")}</Link>
            </h5>
            <h5 className="text-white">
              <Link to={"/business"}>{t("business")}</Link>
            </h5>
            <h5 className="text-white">
              <Link to={"/services"}>{t("services")}</Link>
            </h5>
            <h5 className="text-white">
              <Link to={"/news"}>{t("news")}</Link>
            </h5>
            <h5 className="text-white">
              <Link to={"/gallery"}>{t("gallery")}</Link>
            </h5>
            <h5 className="text-white">
              <Link to={"/contact"}>{t("contact")}</Link>
            </h5>
          </div>
          <div className="sidebar_footer mt-3">
            <div
              className="phone_and_email_sidebar d-flex"
              style={{ flexDirection: "column" }}
            >
              <div className="main-header-three__social sidebar-links mt-2 mx-auto">
                {/* <a href="#" className='text-white'>Sorag-jogap gullugy</a> */}
                <div
                  className="flex flex-row justify-content-between "
                  style={{ width: "100%" }}
                >
                  {items.map((item) => (
                    <div
                      key={item.value}
                      className="bg-transparent cursor-pointer"
                      onClick={() => {
                        i18n.changeLanguage(String(item.value));
                        localStorage.setItem("lang", String(item.value));
                        menuActive();
                      }}
                    >
                      <img src={item.img} alt="" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header_main;
